import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ElementPosition } from '../../utils/prop-types/common-types';

import styles from './styles.css';

const ImageWithText = (props) => {
  const { imageSource, imageName, imageWidth, imageHeight, faIcon, svgContent, faClassName, text, imagePosition, className } = props;

  const textContent = (
    <div className={styles.text}>
      {text}
    </div>
  );

  let imageContent = (
    <img
      src={imageSource}
      alt={imageName}
      width={imageWidth}
      height={imageHeight}
    />
  );

  if (faIcon) {
    imageContent = (
      <FontAwesomeIcon
        icon={faIcon}
        style={{ fontSize: '1.75rem' }}
        className={faClassName}
      />
    );
  }

  if (svgContent) {
    imageContent = svgContent;
  }

  const imagePositionStyle = styles[`imagePosition${imagePosition}`];

  return (
    <div className={`${className} ${styles.container} ${imagePositionStyle}`}>
      <div className={styles.imageContainer}>
        {imageContent}
      </div>
      {textContent}
    </div>
  );
};

ImageWithText.propTypes = {
  text: PropTypes.string,
  imagePosition: ElementPosition,
  imageSource: PropTypes.string,
  imageName: PropTypes.string,
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  faIcon: PropTypes.object,
  svgContent: PropTypes.node,
  faClassName: PropTypes.string,
  className: PropTypes.string,
};

ImageWithText.defaultProps = {
  text: '',
  imagePosition: 'Left',
  imageSource: '',
  imageName: '',
  imageWidth: 30,
  imageHeight: 30,
  faIcon: null,
  svgContent: null,
  faClassName: '',
  className: '',
};

export default ImageWithText;
